import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

import { Separator } from './Separator/Separator';
import { SubTitle } from './SubTitle/SubTitle';

import './css/Title.scss';

const EditConfig = {
  emptyLabel: 'Title',

  isEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
  },
};

const Title = ({ text }) => (
  <div>
    <SubTitle text={text} notFramed />
    <Separator color={getTenantId() === TENANT_ID.AVA ? 'homepage' : 'secondary'} />
  </div>
);

MapTo('e-fix/components/content/title')(Title, EditConfig);

Title.propTypes = {
  text: PropTypes.string.isRequired,
};
